import React from 'react';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Box } from '@mui/material';

function QuickSearchToolbar() {
  return (
    <Box sx={{ p: 1 }}>
      <GridToolbarQuickFilter placeholder="Search…" />
    </Box>
  );
}

export default function DataGridTable({
  rows,
  columns,
  pageSize = 5,
  sx = {},
  stripedColumns = false,
  ...props
}) {

  const baseStyles = {
    p: 0,
    '& .MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: (theme) => theme.palette.action.hover,
    },
    '& .MuiDataGrid-columnHeader': {
      justifyContent: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold',
    },
    '& .MuiDataGrid-cell': {
      whiteSpace: 'normal',
      py: 1,
      px: 1,
      display: 'flex',
      alignItems: 'center',
    },
  };

  const columnStripeStyles = stripedColumns
    ? {
        '& .MuiDataGrid-columnHeader:nth-of-type(even)': {
          backgroundColor: (theme) => theme.palette.action.selected,
        },
        '& .MuiDataGrid-row .MuiDataGrid-cell:nth-of-type(even)': {
          backgroundColor: (theme) => theme.palette.action.selected,
        },
      }
    : {};

  return (
    <DataGrid
      autoHeight
      rows={rows}
      columns={columns}
      disableRowSelectionOnClick
      pageSizeOptions={[5, 10, 20]}
      initialState={{ pagination: { paginationModel: { pageSize } } }}
      slots={{ toolbar: QuickSearchToolbar }}
      getRowHeight={() => 'auto'}
      sx={[baseStyles, columnStripeStyles, sx]}
      {...props}
    />
  );
}
